import Header from '@/components/Header';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';

// import Forbiden403 from '@/pages/403';

import UseWalletConnectHook from '@/hooks/useWalletconnect';
import application from '@/stores/application';
import user from '@/stores/user';
import { observer } from 'mobx-react';
import styled from 'styled-components';

import GlobalDrawer from '@/components/GlobalDrawer';
import IncubatorDrawer from '@/components/IncubatorDrawer';

import TransactionConfirmationModal from '@/components/TransactionConfirmationModal';

import christmasTop from '@/assets/images/christmas-top.png';
import christmasTree from '@/assets/images/christmas_tree.png';
import GlobalSimepleDialog from '@/components/Dialog/GlobalSimpleDialog';
import { routes } from '@/routes';
import serverConfig from '@/stores/serverConfig';
import classNames from 'classnames';
import SignatureModal from './components/SignatureModal';
import { usePageView } from './hooks/usePageView';
import useSignature from './hooks/useSignature';
const Container = styled.div`
    width: 100vw;
    // box-sizing: border-box;
    // padding-top: 93px;
    ${({ theme }) => theme.mediaWidth.upToSmall`
    overflow-x: hidden;
    `};

    background-size: 100% 100%;

    background-repeat: no-repeat;
    background-position: top center;
    background-size: 100% auto;
    background-color: #f5f7ff;

    &.hideBg {
        background-image: none;
        background-color: #f5f7ff;
    }
`;

const MainView: React.FC<{ children: React.ReactNode }> = observer(
    ({ children }) => {
        const location = useLocation();

        const hideChristmasImg = useMemo(() => {
            return location.pathname.indexOf('/lazbubu/') !== -1;
        }, [location.pathname]);

        return (
            <div
                className={`w-screen min-h-[100vh] overflow-hidden bg-background max-md:pt-[60px] pt-[80px] relative transition-all duration-300 ease-in-out ${
                    application.isExploreNavDrawerOpen
                        ? 'md:pl-[240px]'
                        : 'md:pl-0'
                } ${
                    application.isIncubatorDrawerOpen ||
                    application.isLazbubuDrawerOpen
                        ? 'md:pr-[350px]'
                        : 'md:pr-0'
                } ${
                    location.pathname.indexOf('/agent/') !== -1
                        ? 'bg-white'
                        : ''
                }`}
            >
                {!hideChristmasImg && (
                    <>
                        <img
                            src={christmasTop}
                            alt="christmas-top"
                            className="absolute md:top-[80px] top-[60px] left-0 w-full max-md:h-[120px] max-md:object-cover"
                        />
                        <img
                            src={christmasTree}
                            alt="christmas-tree"
                            className="absolute bottom-[40px] right-[40px] h-[200px] max-md:h-[120px] max-md:right-0 max-md:bottom-0"
                        />
                    </>
                )}
                <div className="w-full h-full relative">{children}</div>
            </div>
        );
    },
);

function App() {
    usePageView();
    const { i18n } = useTranslation();
    const location = useLocation();
    const history = useHistory();
    const { showSignatureModal, closeSignatureModal, handleSignSuccess } =
        useSignature();
    // useTokenPrice();

    useEffect(() => {
        const container = document.getElementById('globalContainer');
        container?.scrollTo(0, 0);
    }, [location.pathname]);

    const isComingSoon = useMemo(() => {
        return location.pathname === '/coming-soon';
    }, [location.pathname]);

    const isHideBg = useMemo(() => {
        return (
            location.pathname === '/' ||
            location.pathname === '/exploring-zone' ||
            isComingSoon
        );
    }, [location.pathname, isComingSoon]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const inviteCode = urlParams.get('inviteCode');

        if (inviteCode) {
            user.setReferrerCode(inviteCode);
        }
    }, [location.search]);

    const handleMyLazbubuClick = () => {
        // 处理 My Lazbubu 点击事件
        console.log('My Lazbubu clicked');
    };

    const handleBlindBoxClick = () => {
        // 处理 Blind box 点击事件
        console.log('Blind box clicked');
    };

    const handleGiftClick = () => {
        // 处理 Gift 点击事件
        console.log('Gift clicked');
    };

    useEffect(() => {
        serverConfig.getContract();
    }, [user.chainId]);

    return (
        <>
            <UseWalletConnectHook />
            <TransactionConfirmationModal />
            <SignatureModal
                isOpen={showSignatureModal}
                onClose={closeSignatureModal}
                onSuccess={handleSignSuccess}
            />
            {/* <GlobalLoading /> */}
            <Container
                id="globalContainer"
                className={classNames(
                    isHideBg && 'hideBg',
                    location.pathname.indexOf('/agent/') !== -1 && 'agentBg',
                )}
            >
                <Header />
                <MainView>
                    <GlobalDrawer
                        onMyLazbubuClick={handleMyLazbubuClick}
                        onBlindBoxClick={handleBlindBoxClick}
                        onGiftClick={handleGiftClick}
                    />
                    <IncubatorDrawer />
                    <Switch>
                        {routes.map(({ path, component: Component, exact }) => (
                            <Route key={path} exact={exact} path={path}>
                                <Component />
                            </Route>
                        ))}
                    </Switch>
                </MainView>

                {/* <Footer />   */}
            </Container>
            <GlobalSimepleDialog />
            {/* <GlobalChat /> */}
        </>
    );
}

export default observer(App);
